/**
 * Validate for a valid BIC
 */
export const isValidBIC = (value?: string): string | void =>
  value && !/([a-zA-Z]{4}[a-zA-Z]{2}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)/i.test(value) ? 'global.not_a_valid_bic' : undefined
